import { render, staticRenderFns } from "./CountryRegions.vue?vue&type=template&id=4a9fc39e&scoped=true"
import script from "./CountryRegions.vue?vue&type=script&lang=js"
export * from "./CountryRegions.vue?vue&type=script&lang=js"
import style0 from "./CountryRegions.vue?vue&type=style&index=0&id=4a9fc39e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9fc39e",
  null
  
)

export default component.exports